import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Icon from '../Icon';

const StyledIcon = styled(Icon)`
  fill: none;
`;

const NotifiedMeDarkMode = (props) => {
  const { color, ...rest } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledIcon width="25" height="24" viewBox="0 0 25 24" {...rest}>
      <path
        d="M10.009 18.0025V18.5147C10.009 19.8894 11.1234 21.0038 12.498 21.0038H12.5C13.1604 21.004 13.7939 20.7419 14.261 20.2751C14.7282 19.8084 14.9908 19.1751 14.991 18.5147V18.0025"
        stroke="#F8F8F8"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.4495 18.0025C19.5838 18.0025 20.5033 17.083 20.5033 15.9486C20.5029 15.3724 20.2741 14.8199 19.8671 14.412L18.5025 13.0484V8.99875C18.5025 5.68366 15.8151 2.99625 12.5 2.99625C9.18492 2.99625 6.49751 5.68366 6.49751 8.99875V13.0484L5.13294 14.412C4.72592 14.8199 4.49713 15.3724 4.49667 15.9486C4.49667 16.4934 4.71306 17.0158 5.09823 17.4009C5.48341 17.7861 6.00581 18.0025 6.55053 18.0025H18.4495Z"
        fill="#F8F8F8"
        stroke="#F8F8F8"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.3341 10.2076L12.0427 12.5002L10.6659 11.1246"
        stroke="#2A2B2D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledIcon>
  );
};

NotifiedMeDarkMode.propTypes = {
  color: PropTypes.string
};

NotifiedMeDarkMode.defaultProps = {
  color: 'var(--color-text-primary)'
};

export default NotifiedMeDarkMode;
